import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'sl',
  months: [
    'januar',
    'februar',
    'marec',
    'april',
    'maj',
    'junij',
    'julij',
    'avgust',
    'september',
    'oktober',
    'november',
    'december',
  ],
  monthsShort: ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'avg.', 'sep.', 'okt.', 'nov.', 'dec.'],
  weekdays: ['nedelja', 'ponedeljek', 'torek', 'sreda', 'četrtek', 'petek', 'sobota'],
  weekdaysMin: ['n', 'p', 't', 's', 'č', 'p', 's'],
  weekdaysShort: ['ned.', 'pon.', 'tor.', 'sre.', 'čet.', 'pet.', 'sob.'],
  formats: {
    LT: 'HH.mm',
    LTS: 'HH:mm:ss',
    lt: 'HH.mm',
    lts: 'HH:mm:ss',
    L: 'D. M. YYYY',
    LL: 'D. MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D. MMMM',
    LLL: 'D. MMMM YYYY HH.mm',
    'LLL-Y': 'D. MMMM HH.mm',
    LLLL: 'dddd, D. MMMM YYYY HH.mm',
    'LLLL-Y': 'dddd D. MMMM HH.mm',
    l: 'D. M. YYYY',
    'l-Y': 'D. M.',
    ll: 'D. MMM YYYY',
    'll-Y': 'D. MMM',
    'll-D': 'MMM YYYY',
    lll: 'D. MMM YYYY HH.mm',
    'lll-Y': 'D. MMM HH.mm',
    llll: 'ddd, D. MMM YYYY HH.mm',
    'llll-Y': 'ddd, D. MMM HH.mm',
    'll-Y+w': 'ddd, D. MMM',
    'LT+to': 'HH.mm ([GMT]Z)',
    'LLL+to': 'D. MMMM YYYY HH.mm ([GMT]Z)',
  },
  meridiem: { am: 'dop.', pm: 'pop.', AM: 'dop.', PM: 'pop.' },
  past: {
    y: { one: 'pred %s letom', two: 'pred %s letoma', few: 'pred %s leti', other: 'pred %s leti' },
    M: { one: 'pred %s mes.', two: 'pred %s mes.', few: 'pred %s mes.', other: 'pred %s mes.' },
    w: { one: 'pred %s ted.', two: 'pred %s ted.', few: 'pred %s ted.', other: 'pred %s ted.' },
    d: { one: 'pred %s dnevom', two: 'pred %s dnevoma', few: 'pred %s dnevi', other: 'pred %s dnevi' },
    h: { one: 'pred %s uro', two: 'pred %s urama', few: 'pred %s urami', other: 'pred %s urami' },
    m: { one: 'pred %s min.', two: 'pred %s min.', few: 'pred %s min.', other: 'pred %s min.' },
    s: { one: 'pred %s s', two: 'pred %s s', few: 'pred %s s', other: 'pred %s s' },
  },
  future: {
    y: { one: 'čez %s leto', two: 'čez %s leti', few: 'čez %s leta', other: 'čez %s let' },
    M: { one: 'čez %s mes.', two: 'čez %s mes.', few: 'čez %s mes.', other: 'čez %s mes.' },
    w: { one: 'čez %s ted.', two: 'čez %s ted.', few: 'čez %s ted.', other: 'čez %s ted.' },
    d: { one: 'čez %s dan', two: 'čez %s dneva', few: 'čez %s dni', other: 'čez %s dni' },
    h: { one: 'čez %s uro', two: 'čez %s uri', few: 'čez %s ure', other: 'čez %s ur' },
    m: { one: 'čez %s min.', two: 'čez %s min.', few: 'čez %s min.', other: 'čez %s min.' },
    s: { one: 'čez %s s', two: 'čez %s s', few: 'čez %s s', other: 'čez %s s' },
  },
  pastLong: {
    y: { one: 'pred %s letom', two: 'pred %s letoma', few: 'pred %s leti', other: 'pred %s leti' },
    M: { one: 'pred %s mesecem', two: 'pred %s mesecema', few: 'pred %s meseci', other: 'pred %s meseci' },
    w: { one: 'pred %s tednom', two: 'pred %s tednoma', few: 'pred %s tedni', other: 'pred %s tedni' },
    d: { one: 'pred %s dnevom', two: 'pred %s dnevoma', few: 'pred %s dnevi', other: 'pred %s dnevi' },
    h: { one: 'pred %s uro', two: 'pred %s urama', few: 'pred %s urami', other: 'pred %s urami' },
    m: { one: 'pred %s minuto', two: 'pred %s minutama', few: 'pred %s minutami', other: 'pred %s minutami' },
    s: { one: 'pred %s sekundo', two: 'pred %s sekundama', few: 'pred %s sekundami', other: 'pred %s sekundami' },
  },
  futureLong: {
    y: { one: 'čez %s leto', two: 'čez %s leti', few: 'čez %s leta', other: 'čez %s let' },
    M: { one: 'čez %s mesec', two: 'čez %s meseca', few: 'čez %s mesece', other: 'čez %s mesecev' },
    w: { one: 'čez %s teden', two: 'čez %s tedna', few: 'čez %s tedne', other: 'čez %s tednov' },
    d: { one: 'čez %s dan', two: 'čez %s dneva', few: 'čez %s dni', other: 'čez %s dni' },
    h: { one: 'čez %s uro', two: 'čez %s uri', few: 'čez %s ure', other: 'čez %s ur' },
    m: { one: 'čez %s minuto', two: 'čez %s minuti', few: 'čez %s minute', other: 'čez %s minut' },
    s: { one: 'čez %s sekundo', two: 'čez %s sekundi', few: 'čez %s sekunde', other: 'čez %s sekund' },
  },
  abbr: {
    y: { one: '%s l', two: '%s l', few: '%s l', other: '%s l' },
    M: { one: '%s m', two: '%s m', few: '%s m', other: '%s m' },
    w: { one: '%s t', two: '%s t', few: '%s t', other: '%s t' },
    d: { one: '%s d', two: '%s d', few: '%s d', other: '%s d' },
    h: { one: '%s h', two: '%s h', few: '%s h', other: '%s h' },
    m: { one: '%s min', two: '%s min', few: '%s min', other: '%s min' },
    s: { one: '%s sek.', two: '%s sek.', few: '%s sek.', other: '%s sek.' },
  },
  full: {
    y: { one: '%s leto', two: '%s leti', few: '%s leta', other: '%s let' },
    M: { one: '%s mesec', two: '%s meseca', few: '%s meseci', other: '%s mesecev' },
    w: { one: '%s teden', two: '%s tedna', few: '%s tedni', other: '%s tednov' },
    d: { one: '%s dan', two: '%s dneva', few: '%s dnevi', other: '%s dni' },
    h: { one: '%s ura', two: '%s uri', few: '%s ure', other: '%s ur' },
    m: { one: '%s minuta', two: '%s minuti', few: '%s minute', other: '%s minut' },
    s: { one: '%s sekunda', two: '%s sekundi', few: '%s sekunde', other: '%s sekund' },
  },
  justNow: 'zdaj',
  yesterday: 'včeraj',
  today: 'danes',
  tomorrow: 'jutri',
  weekStart: 1,
  timeRange: '%$1s–%$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D. MMMM YYYY', end: 'D. MMMM YYYY' },
    'yl-1': { start: 'D. MMMM', end: 'D. MMMM YYYY' },
    ml: { start: 'D. MMMM', end: 'D. MMMM' },
    'ml-1': { start: 'D.', end: 'D. MMMM YYYY' },
    dl: { start: 'D.', end: 'D. MMMM' },
    y: { start: 'D. MMM YYYY', end: 'D. MMM YYYY' },
    'y-1': { start: 'D. MMM', end: 'D. MMM YYYY' },
    m: { start: 'D. MMM', end: 'D. MMM' },
    'm-1': { start: 'D.', end: 'D. MMM YYYY' },
    d: { start: 'D.', end: 'D. MMM' },
    Y: { start: 'ddd, D. MMM YYYY', end: 'ddd, D. MMM YYYY' },
    'Y-1': { start: 'ddd, D. MMM', end: 'ddd, D. MMM YYYY' },
    M: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    D: { start: 'ddd, D. MMM', end: 'ddd, D. MMM' },
    yt: { start: 'D. MMM YYYY HH.mm', end: 'D. MMM YYYY HH.mm' },
    mt: { start: 'D. MMM HH.mm', end: 'D. MMM HH.mm' },
    dt: { start: 'D. MMM HH.mm', end: 'D. MMM HH.mm' },
    t: { start: 'H.mm', end: 'H.mm' },
    'yt+to': { start: 'D. MMM YYYY HH.mm', end: 'D. MMM YYYY HH.mm ([GMT]Z)' },
    'mt+to': { start: 'D. MMM HH.mm', end: 'D. MMM HH.mm ([GMT]Z)' },
    'dt+to': { start: 'D. MMM HH.mm', end: 'D. MMM HH.mm ([GMT]Z)' },
    't+to': { start: 'H.mm', end: 'H.mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'sl';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}.`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'dop.' : 'dop.';
    } else {
      return isLowerCase ? 'pop.' : 'pop.';
    }
  },
};
